import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BlockAbstractComponent, UtilsModule } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-timeline',
    templateUrl: './block-timeline.component.html',
    styleUrls: ['./block-timeline.component.scss'],
    standalone: true,
    imports: [CommonModule, UtilsModule],
})
export class BlockTimelineComponent extends BlockAbstractComponent {
    private sanitizer = inject(DomSanitizer);

    getIconUrl(url: string): SafeResourceUrl {
        if (!url) {
            return '';
        }

        if (!url.includes('https://') && !url.includes('http://')) {
            url = (this.configService.get('frontend') ?? '') + url;
        }

        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
